import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
`;

const PillButton = styled(Button)`
  /* Required to override antd's button font-weight; setting font-regular alone isn't enough */
  font-weight: 400;
  border-radius: 25px;
  height: 26px;
  font-size: 12px;
  padding: 5px 10.5px;
`;

const LabelWithCount = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Count = styled.span`
  color: var(--text-secondary);
  font-size: 10px;

  &.active {
    color: inherit;
  }
`;

type Item<K extends string | number> = {
  key: K;
  label: React.ReactNode;
  count?: number;
};

type Props<K extends string | number> = {
  items: Item<K>[];
  activeKey: K;
  onChange: (key: K) => void;
  className?: string;
  getItemTestId?: (key: K) => string;
};

const PillSwitcher = <K extends string | number>({
  items,
  activeKey,
  onChange,
  className,
  getItemTestId,
}: Props<K>) => (
  <Container className={className}>
    {items.map((item) => (
      <PillButton
        key={String(item.key)}
        onClick={() => onChange(item.key)}
        type={activeKey === item.key ? 'primary' : undefined}
        data-testid={getItemTestId?.(item.key)}
      >
        {item.count === undefined ? (
          item.label
        ) : (
          <LabelWithCount>
            <span>{item.label}</span>
            <Count className={activeKey === item.key ? 'active' : ''}>{item.count}</Count>
          </LabelWithCount>
        )}
      </PillButton>
    ))}
  </Container>
);

export default PillSwitcher;
